<div class="wrapper">
  <div class="minimize-icon">
    <markant-icon-button
      icon="m_minimize"
      [routerLink]="['/']"
    ></markant-icon-button>
  </div>
  <router-outlet *ngIf="!error; else errorWrapper"></router-outlet>
  <ng-template #errorWrapper>
    <div class="error-wrapper flex-centered">
      <markant-callout colorScheme="error" theme="colored">
        <div slot="content">
          <div class="callout-content flex-centered">
            <span class="error-circle flex-centered"> &times; </span>
            <p>
              {{ 'dashboard.cartridge.widget.error' | transloco }}
            </p>
          </div>
        </div>
      </markant-callout>
    </div>
  </ng-template>
</div>
